import { Chip as Chip_, Accordion as Accordion_, FlexContainer } from '@taxdown/piccolo-web';
import styled from 'styled-components';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const Chip = styled<{ isPayLater: boolean }>(Chip_)`
  display: ${({ isPayLater }) => (isPayLater ? 'none' : 'flex')};
`;

export const Accordion = styled(Accordion_)`
  display: none;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    display: flex;
    background: ${({ theme: { system } }) => system.background.fds_sys_color_background_primary};
    width: 100%;
  }
`;

export const DesktopContainer = styled(FlexContainer)`
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    display: none;
  }
`;
